import * as React from "react";
import { PlusIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { api } from "../../api";
import { useUser } from "../../state";

export function TagAdder({
  entry_id,
  onAddTag,
}: {
  entry_id: number;
  onAddTag: (tag: string) => void;
}): JSX.Element {
  const userState = useUser();
  const user = userState.type === "logged-in" ? userState.user : undefined;
  const [expanded, setExpanded] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const toggleExpand = () => setExpanded((prev) => !prev);

  const handleKey = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = inputRef.current;
    if (!input) return;

    if (e.key === "Escape") {
      setExpanded(false);
      return;
    }

    if (e.key === "Enter") {
      if (input.value.trim() === "") {
        alert(`Please type an ACTUAL tag, ${user ? user.username : "friend"}. smh`);
        return;
      }

      const res = await api.post<"/api/entry/:entry_id/tag">(
        `/api/entry/${entry_id}/tag`,
        {
          tag: input.value,
        }
      );

      if (api.isErrorToast(res)) {
        return;
      }

      onAddTag(input.value);
      setExpanded(false);
    }
  };

  if (!user) {
    return <></>;
  }

  if (expanded) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white py-0.5 pl-2.5 pr-1 dark:border-slate-600 dark:bg-slate-800">
        <input
          ref={inputRef}
          className="w-20 border-none bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400 dark:text-slate-300 dark:placeholder:text-slate-500"
          onKeyDown={handleKey}
          type="text"
          placeholder="new tag"
        />
        <button
          onClick={toggleExpand}
          className="rounded-full p-0.5 text-slate-400 transition-colors hover:bg-slate-200 hover:text-slate-600 dark:text-slate-500 dark:hover:bg-slate-700 dark:hover:text-slate-300"
        >
          <XMarkIcon className="h-3.5 w-3.5" />
        </button>
      </span>
    );
  }

  return (
    <button
      onClick={toggleExpand}
      className="inline-flex items-center gap-0.5 rounded-full border border-dashed border-slate-300 px-2 py-0.5 text-sm text-slate-500 transition-colors hover:border-slate-400 hover:bg-slate-100 hover:text-slate-600 dark:border-slate-600 dark:text-slate-400 dark:hover:border-slate-500 dark:hover:bg-slate-700 dark:hover:text-slate-300"
    >
      <PlusIcon className="h-3.5 w-3.5" />
      add tag
    </button>
  );
}
